import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Facebook } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const tahun = new Date().getFullYear();


  return (
    <footer className="w-full bg-red-700 text-white px-4 py-8">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Company Info */}
        <div className="flex flex-col space-y-2">
          <h3 className="font-semibold mb-2  text-xl">Vavelle & Co<br></br> Car Rental</h3>
          <div className=" text-xl">
            <p className="font-semibold mb-1">Hours:</p>
            <p>Mon - Fri: 9 AM - 6 PM</p>
            <p>Sat: 9 AM - 12 PM</p>
            <p>Sun: Closed</p>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="flex justify-center md:justify-start space-x-12 text-xl">
          <div className="flex flex-col space-y-2">
          <Link
              to="/"
              className={`hover:underline ${location.pathname.includes('/') ? 'active' : ''}`}
            >
              Beranda
            </Link>            
            <Link
              to="/tentang-kami"
              className={`hover:underline ${location.pathname.includes('/tentang-kami') ? 'active' : ''}`}
            >
              Tentang Kami
            </Link>
            <Link
              to="/tnc"
              className={`hover:underline ${location.pathname.includes('/tnc') ? 'active' : ''}`}
            >
              FAQ
            </Link>            
            <Link
              to="/kendaraan"
              className={`hover:underline ${location.pathname.includes('/kendaraan') ? 'active' : ''}`}
            >
              Vehicles
            </Link>
            {/* <Link
              to="/Lokasi"
              className={`hover:underline ${location.pathname.includes('/Lokasi') ? 'active' : ''}`}
            >
              Lokasi
            </Link> */}
          </div>
          <div className="flex flex-col space-y-2">
            <Link
              to="/pembayaran"
              className={`hover:underline ${location.pathname.includes('/pembayaran') ? 'active' : ''}`}
            >
              Make Payments
            </Link>
            <Link
              to="/kontak-kami"
              className={`hover:underline ${location.pathname.includes('/kontak-kami') ? 'active' : ''}`}
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Social Media */}
        <div className="flex justify-center md:justify-end">
          <a href="https://www.facebook.com/YourPage" className="hover:text-gray-200">
            <Facebook size={24} />
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className="max-w-6xl mx-auto mt-8 text-sm">
        <p>© {tahun} by Vavelle & Co Rental Mobil. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
